var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAlertWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.791504 16.6247L9.49984 1.58301L18.2082 16.6247H0.791504ZM9.49984 14.2497C9.72414 14.2497 9.91216 14.1738 10.0639 14.0221C10.2156 13.8703 10.2915 13.6823 10.2915 13.458C10.2915 13.2337 10.2156 13.0457 10.0639 12.8939C9.91216 12.7422 9.72414 12.6663 9.49984 12.6663C9.27553 12.6663 9.08751 12.7422 8.93578 12.8939C8.78404 13.0457 8.70817 13.2337 8.70817 13.458C8.70817 13.6823 8.78404 13.8703 8.93578 14.0221C9.08751 14.1738 9.27553 14.2497 9.49984 14.2497ZM8.70817 11.8747H10.2915V7.91634H8.70817V11.8747Z",
    fill: "#344054"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlertWarning);
export default __webpack_public_path__ + "static/media/icon-alert-warning.20e29fbafa9a557bbeae519a22ab4085.svg";
export { ForwardRef as ReactComponent };